(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-main"]) return;
  try {
    
  {
    const hardwareType = [];
                hardwareType['gryphon'] = 'Gryphon Tower';
                hardwareType['guardian'] = 'Gryphon Guardian';
                hardwareType['gryphonpro'] = 'Gryphon AX';
    const gryphonEmailBtn = document.getElementById("gryphonEmailBtn");
    const loadingText = "Loading Subscription Options. Please wait...";
    const errorNotExistsNotPaired = `We found no device associated with this email. 
                                    Please pair your Gryphon router with the Gryphon Connect app and 
                                    try again or check if you have used a different email address.`;
    const deviceOptionPlanWrapper = document.getElementById("deviceOptionPlanWrapper");
    const errorResponseStatusError = `Sorry, but there was an error retrieving your subscription options. 
            Please try again.<br/><a href='https://gryphonconnect.com/pages/subscribe-now'>[CLICK TO REFRESH]</a>`;
    const networkResponseError = "Network response was not OK";
    const emailError = "Please enter email.";
    const emailNotValidError = "Please enter valid email.";
    const deviceIdNotEntered = "Please select device id from the list.";
    const subscriptionPageUrl = 'https://gryphonconnect.com/pages/subscribe-now';
    const emailDoesNotExist = "We couldn't find this email address in our system. Please check and enter correct email address that you used to create Gryphon account.";

    
    //Main functionality part    
    gryphonEmailBtn.addEventListener('click', function(){
        
        const userEmail = document.getElementById("userEmail");        
        const email = userEmail.value;
        deviceOptionPlanWrapper.innerHTML = "";        
        const subscriptionValidateUserByEmailIdApiUrl = "https://shepherd-staging.wegryphon.com:3000/rest/cross-server-communication/validate-user-by-email-id";
        const deviceOptionWrapper = document.getElementById("deviceOptionWrapper");
        deviceOptionWrapper.className = "loading-text";
        if(userEmail.value == ""){
          deviceOptionWrapper.innerText = emailError;
          return false;
        }else if( userEmail.value != "" && ! /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(userEmail.value)){
          deviceOptionWrapper.innerText = emailNotValidError;
          return false;
        }else{
            deviceOptionWrapper.innerText = loadingText;
            fetch(subscriptionValidateUserByEmailIdApiUrl , {
                            method: 'POST',
                            mode: 'cors',
                            body: JSON.stringify({
                                  email:email                    
                            }), 
                            headers: {                          
                              'Content-Type': 'application/json; charset=UTF-8',
                              'api_key': 'gJnqtFjfKwHd6wTCPNx89QUVn3SrnZx2DTze',
                              'cache-control': 'no-cache'
                              
                            }                            
                        }
          ).then(response => {
            //handle response            
            if (!response.ok && response.status === 400) {
              throw new Error(emailDoesNotExist);
            }else if (!response.ok && response.status === 500) {
              throw new Error(networkResponseError);
            }
            return response.json();
              
         }).then(data => {
            //handle data
            deviceOptionWrapper.innerText = "";             
            if(data.status === "error" && data.user_exists === false && data.is_paired === false ){
              deviceOptionWrapper.innerText = data.message;
            }else if( data.status === "ok" && data.user_exists === true && data.is_paired === false){
              deviceOptionWrapper.innerText = errorNotExistsNotPaired;
            }else if( data.status === "ok" && data.user_exists === true && data.is_paired === true){
              
              if( ( data.device_ids.length > 0 ) && ( data.device_ids.length == 1 ) ){
                
                //deviceOptionWrapper.innerText = "User has only one device id"; 
                const deveiceOptionHtml = '<input type="hidden" class="form-control" name="device_id" id="deviceIdOption" value="'+data.device_list[0].hardware_type +'::'+ data.device_list[0].device_id+'">';
                deviceOptionWrapper.innerHTML = deveiceOptionHtml;
                getPlanByHardwareAndDeviceId(data.device_list[0].hardware_type +'::'+ data.device_list[0].device_id, 1);
                
                
              }else{                
                
                let deveiceOptionHtml = '<select class="form-control" name="deveice_id" id="deviceIdOption">';
                deveiceOptionHtml += '<option value="">--Select device --</option>';
                if(data.device_ids.length > 0){
                  Object.keys(data.device_ids).forEach(key => {
                    //console.log(key + ' - ' + data.device_ids[key].device_id);
                    deveiceOptionHtml += '<option value="'+data.device_ids[key].hardware_type+'::'+data.device_ids[key].device_id+'">'+ capitalizeFirstLetter(hardwareType[data.device_ids[key].hardware_type]) +' </option>';
                
                  });
                }
                deveiceOptionHtml += '</select>';
                deviceOptionWrapper.innerHTML =  deveiceOptionHtml;
                deviceOptionWrapper.className += ' device-ddl';
                const deviceIdOption = document.getElementById("deviceIdOption");
                deviceIdOption.addEventListener('change', function(){
                    getPlanByHardwareAndDeviceId(this.value, 0);
                });
              }
              
            }else{
              deviceOptionWrapper.innerHTML = errorResponseStatusError;
            }
        })
        .catch(error => {
            //handle error
            deviceOptionWrapper.innerText = error;            
        });

      }      
      
    });
    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    function getPlanByHardwareAndDeviceId(deviceId, type){
      
      if(deviceId == ""){

        deviceOptionPlanWrapper.innerText = deviceIdNotEntered;
        return false;
        
      }
      const deviceIdArray = deviceId.split("::");
      deviceOptionPlanWrapper.innerText = "";
      if(!type){
        deviceOptionPlanWrapper.innerText = loadingText;
      }
      
      const userEmail = document.getElementById("userEmail");        
      const email = userEmail.value;
      const subscriptionPlanApiUrl = "https://shepherd-staging.wegryphon.com:3000/rest/cross-server-communication/get-web-subscription-plans?email="+email+"&device_id="+deviceIdArray[1];    
            fetch(subscriptionPlanApiUrl , {
                            method: 'GET',
                            mode: 'cors', 
                            headers: {                          
                              'Content-Type': 'application/json; charset=UTF-8',
                              'api_key': 'gJnqtFjfKwHd6wTCPNx89QUVn3SrnZx2DTze',
                              'cache-control': 'no-cache'
                              
                            }                            
                        }
          ).then(response => {
              
            //handle response
            if (!response.ok && response.status === 400) {
              throw new Error(emailDoesNotExist);
            }else if (!response.ok && response.status === 500) {
              throw new Error(networkResponseError);
            }
            return response.json();
              
         }).then(result => {
              
              if(result.status === "ok"){
                  let planHtml = '';
                  Object.keys(result.data).forEach( key => {
                        //console.log("Result Data - ", key, result.data[key]);
                        let marginLeft = 'style="margin-left:0px;margin-bottom: 25px!important;padding:3% !important"';
                        let wpb_column_class = "vc_col-sm-6";
                        if( key%2 == 0){
                            marginLeft = 'style="margin-left:2.1%;margin-bottom: 10px!important;padding:3% !important"';
                        }
                    
                        if(result.data.length == 1){
                           wpb_column_class = "vc_col-sm-12";                         
                        }
                    
                        planHtml += '<div '+marginLeft+' class="'+wpb_column_class+' wpb_column column_container vc_column_container col padding-3-percent" data-using-bg="true" data-t-w-inherits="default" data-shadow="none" data-border-radius="none" data-border-animation="" data-border-animation-delay="" data-border-width="none" data-border-style="solid" data-border-color="" data-bg-cover="" data-padding-pos="all" data-has-bg-color="true" data-bg-color="#f2f2f2" data-bg-opacity="1" data-hover-bg="" data-hover-bg-opacity="1" data-animation="" data-delay="0"><div class="column-bg-overlay" style="opacity: 1; background-color: #f9f9f9;">';
                        planHtml += '</div>';
                        planHtml += '<div class="vc_column-inner">';
                        planHtml += '<div class="wpb_wrapper">';
                        if(result.data[key].subscription_charge_frequency == 'yearly'){
                          planHtml += '<h2 style="font-size: 25px;font-weight:500;line-height: 1.3;text-align: center" class="vc_custom_heading no-spaces-name year1-security-subscription-txt vc_custom_1572280076357">Billed Annually</h2>';
                        }else{
                           planHtml += '<h2 style="font-size: 25px;font-weight:500;line-height: 1.3;text-align: center" class="vc_custom_heading no-spaces-name year1-security-subscription-txt vc_custom_1572280076357">Billed '+capitalizeFirstLetter(result.data[key].subscription_charge_frequency)+'</h2>';
                        }
                        
                        planHtml += '<h2 style="text-align: center;" class="vc_custom_heading no-spaces-name year1-security-subscription-price vc_custom_1593496027266"> $'+result.data[key].subscription_offer_price +'</h2>';
                        planHtml += ' </div>';
                        planHtml += '</div>';
                        planHtml += '</div>';
                        planHtml += '<form action="https://subscribe.gryphonconnect.com/subscription/index.php" method="POST" name="'+result.data[key].subscription_id +'_form" id="'+result.data[key].subscription_id +'_form">';
                        planHtml += '<input type="hidden" name="s_id" id="s_id" value="'+result.data[key].subscription_id +'">';
                        planHtml += '<input type="hidden" name="s_device_type" id="s_device_type" value="desktop"><input type="hidden" name="s_type" id="s_type" value="'+result.data[key].subscription_charge_frequency+'">';
                        planHtml += '<input type="hidden" name="s_price" id="s_price" value="'+result.data[key].subscription_offer_price+'"><input type="hidden" name="s_title" id="s_title" value="">';
                        planHtml += '<input type="hidden" name="s_decription" id="s_decription" value="'+result.data[key].subscription_title + '"><input type="hidden" name="s_email" id="s_email" value="'+$('#userEmail').val()+'">';
                        if(result.data[key].subscription_charge_frequency == 'yearly'){
                          planHtml += '<input type="hidden" name="plan_duration" id="plan_duration" value="Gryphon Premium Protection - Billed Annually">';
                        }else{
                          planHtml += '<input type="hidden" name="plan_duration" id="plan_duration" value="Gryphon Premium Protection - Billed '+capitalizeFirstLetter(result.data[key].subscription_charge_frequency)+'">';
                        }
                        planHtml += '<input type="hidden" name="s_addons_id" id="s_addons_id" value="">';
                        planHtml += '<input type="hidden" name="subscription_type" id="subscription_type" value="'+result.data[key].subscription_type+'"><input type="hidden" name="subscribe_plan" id="subscribe_plan" value="Y">';
                        planHtml += '<input type="hidden" name="page_url" id="page_url" value="'+subscriptionPageUrl+'">';
                        planHtml += '<div class="btn-box"><input type="submit" name="'+result.data[key].subscription_id +'-subscription" id="'+result.data[key].subscription_id +'-subscription" class="btn sm subscribe-btn" value="SUBSCRIBE NOW" /></div>';
                        planHtml += '</form>';
                        planHtml += '<div><p class="coupon-msg">Coupon codes can be applied during checkout.</p></div>';
                        
                    
                  }); 
                 
                deviceOptionPlanWrapper.innerHTML = planHtml;
                 
              }else{
                deviceOptionPlanWrapper.innerHTML = errorResponseStatusError
              }
              
         }).catch(error => {              
              deviceOptionPlanWrapper.innerHTML = error;              
         });
    }   
  
  }
  

  } catch(e) { console.error(e); }
})();
})();
